'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Prefixes = exports.Prefixes = {
  vx: 'vision',
  de: 'data-explorer',
  dlm: 'data-lifecycle-manager'
};

var Colors = exports.Colors = {
  GREY1: '#F0F0F0',
  GREY2: '#CCCCCC',
  GREY3: '#494444',
  GREY4: '#A4A1A1',
  GREY5: '#666666',
  BLUE1: '#2973BD',
  BLUE2: '#0965C1',
  WHITE1: '#FFFFFF',
  GREEN1: '#8CC841'
};

var FontSizes = exports.FontSizes = {
  SIZE1: 18,
  SIZE2: 14,
  SIZE3: 12
};

var Formats = exports.Formats = {
  WIDE: 'initial',
  NARROW: 360
};

var Layout = exports.Layout = {
  PADDING: '5%',
  SIDE_WIDTH: 300,
  FILTER_MAX_HEIGHT: 250
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/commons/tokens/index.js
// module id = 2012
// module chunks = 0